import React from 'react';
import {
  Box,
  IconButton,
  Input,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Tooltip,
  HStack,
  Text,
  Button,
} from '@chakra-ui/react';
import { DeleteIcon, TimeIcon } from '@chakra-ui/icons';

const WarehouseTable = ({
  items,
  onRename,
  onOpenMinQuantityModal,
  onDelete,
  onOpenHistory,
  onOpenQuantityModal,
}) => {
  const handleNameBlur = (item, event) => {
    const newName = event.target.value.trim();
    if (!newName || newName === item.name) return;
    onRename(item.id, newName);
  };

  return (
    <Box overflowX='auto'>
      <Table size='sm' variant='simple'>
        <Thead>
          <Tr>
            <Th color='white'>Prodotto</Th>
            <Th color='white'>Quantità</Th>
            <Th color='white'>Soglia minima</Th>
            <Th color='white' isNumeric>
              Azioni
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {items.map((item) => {
            const isBelowMin =
              typeof item.minQuantity === 'number' &&
              item.minQuantity > 0 &&
              item.quantity < item.minQuantity;

            return (
              <Tr key={item.id}>
                <Td>
                  <Input
                    defaultValue={item.name}
                    size='sm'
                    variant='flushed'
                    color='white'
                    onBlur={(e) => handleNameBlur(item, e)}
                  />
                </Td>
                <Td>
                  <Text
                    minW='40px'
                    textAlign='center'
                    color={isBelowMin ? 'red.300' : 'white'}
                    fontWeight={isBelowMin ? 'bold' : 'normal'}
                  >
                    {item.quantity}
                  </Text>
                </Td>
                <Td>
                  <Text>{item.minQuantity || 0}</Text>
                </Td>
                <Td isNumeric>
                  <HStack justify='flex-end' spacing={2}>
                    <Button
                      size='sm'
                      onClick={() => onOpenQuantityModal(item, 'deposito')}
                    >
                      +
                    </Button>
                    <Button
                      size='sm'
                      onClick={() => onOpenQuantityModal(item, 'prelievo')}
                    >
                      -
                    </Button>
                    <Button
                      size='sm'
                      
                      onClick={() => onOpenMinQuantityModal(item)}
                    >
                      Soglia
                    </Button>
                    <Tooltip label='Storico movimenti'>
                      <IconButton
                        aria-label='Storico movimenti'
                        icon={<TimeIcon />}
                        size='sm'
                        onClick={() => onOpenHistory(item)}
                      />
                    </Tooltip>
                    <Tooltip label='Elimina prodotto'>
                      <IconButton
                        aria-label='Elimina'
                        icon={<DeleteIcon />}
                        size='sm'
                        onClick={() => onDelete(item)}
                      />
                    </Tooltip>
                  </HStack>
                </Td>
              </Tr>
            );
          })}
          {items.length === 0 && (
            <Tr>
              <Td colSpan={5}>
                <Text fontSize='sm'>Nessun prodotto in magazzino.</Text>
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </Box>
  );
};

export default WarehouseTable;

